"use client";

import { useState } from "react";

export default function SubscribeForm(props: Readonly<{ variant?: "compact" | "wide" }>) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [error, setError] = useState<string | null>(null);
  const compact = props.variant !== "wide";

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setStatus("loading");
    setError(null);
    try {
      const res = await fetch("/api/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (!res.ok || !data?.ok) throw new Error(data?.error || "Failed");
      setStatus("success");
      window.dispatchEvent(
        new CustomEvent("analytics", { detail: { event: "subscribe_success" } })
      );
    } catch (err: any) {
      setStatus("error");
      setError(err?.message || "Something went wrong");
    }
  }

  return (
    <form
      onSubmit={onSubmit}
      className={compact ? "flex gap-2" : "grid gap-3 sm:grid-cols-[1fr_auto]"}
    >
      <div className="relative">
        <label htmlFor="email" className="sr-only">
          Email
        </label>
        <input
          id="email"
          type="email"
          required
          autoComplete="email"
          placeholder="you@company.com"
          value={email}
          onChange={e => setEmail(e.target.value)}
          className="w-full rounded-lg border border-white/15 bg-transparent px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-blue"
          aria-invalid={status === "error"}
        />
        {status === "error" && error && (
          <p className="mt-1 text-xs text-red-500" role="alert">
            {error}
          </p>
        )}
      </div>
      <button
        type="submit"
        disabled={status === "loading"}
        className="inline-flex h-10 items-center justify-center rounded-xl bg-blue px-4 text-sm font-semibold text-white shadow-sm transition-colors hover:brightness-110 disabled:opacity-60"
        data-cta="subscribe-submit"
      >
        {status === "loading" ? "Subscribing…" : status === "success" ? "Subscribed" : "Subscribe"}
      </button>
    </form>
  );
}
